/**
 * Media types used by the frontend app.
 */
export const MediaType = {
  JSON: 'application/json',
  CSV: 'text/csv'
}
